/**
 * Created by Rodrigo Quesada on 01/03/17.
 */
export const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/infrastructure/recaptcha/recaptcha.config.ts